import React from 'react';
import HeaderLeftCol from './Components/HeaderLeftCol';
import HeaderRightCol from './Components/HeaderRightCol/HeaderRightCol';

function WebHeaderPage() {
    return (
        <div className="web-header">
            <HeaderLeftCol />
            <HeaderRightCol />
        </div>
    );
}

export default WebHeaderPage;
